import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getEventStakes, GetEventStakesParams} from '../api';
import {QUERY__EVENT_STAKES} from '../queryKeys';
import {Stake} from '../types';

export const useGetEventStakes = <SelectedData = GetListOutput<Stake>>(
  params: GetEventStakesParams,
  options?: QueryOptionsForList<Stake, SelectedData>,
) =>
  useQuery({
    queryKey: [QUERY__EVENT_STAKES, params],
    queryFn: () => getEventStakes(params),
    ...options,
  });
